module.exports = __webpack_public_path__ + "static/media/ThirdBackground.47bdeb60.svg";